import { STOP_OOS_STORE_TOOLTIP } from '../actionTypes/DeliveryOptionActionTypes';

function DeliveryOptionsReducer(state = {}, action) {
    switch (action.type) {
        case STOP_OOS_STORE_TOOLTIP: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default:
            return state;
    }
}

export default DeliveryOptionsReducer;
